// extracted by mini-css-extract-plugin
export default {"btn":"Box_btn__iNkyN","box":"Box_box__6XAdY"};